import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  Dropdown, DropdownItem, DropdownMenu, DropdownToggle 
} from "reactstrap";
import loginbg from "../../assets/images/loginbg.png";
import findagramLogo from "../../assets/images/logoFindagram.png";
import ApiClient from "../BaseUrl/ApiClient";
import "./CardDetails.css";
import { Link, useHistory, useLocation } from "react-router-dom";
import {
  useStripe,
  useElements,
  PaymentElement,
  Elements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

function StripePaymentForm({ clientSecret, planType }) {
  const [email, setEmail] = useState("");
  const [cardholder, setCardholder] = useState("");
  const [loading, setLoading] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) {
      toast.error("Stripe not initialized");
      return;
    }
    setLoading(true);
    try {
      const { setupIntent, error } = await stripe.confirmSetup({
        elements,
        confirmParams: {},
        redirect: "if_required",
      });
      if (error) {
        toast.error(error.message);
        setLoading(false);
        return;
      }
      if (setupIntent?.status === "succeeded") {
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        const payload = {
          stripeCustomerId: authUser?.stripeCustomerId || "68779fe49b6750e94186ad19",
          stripePaymentMethodId: setupIntent.payment_method,
          planType: planType || 1, // Default to Standard plan if not provided
        };
        ApiClient()
          .post("/business/payment/card", payload)
          .then((response) => {
            const { responseData } = response.data;
            const { subscriptionInfo, data, businessProfile } = responseData;
            if (data && data.user.roleType !== 1) {
              throw new Error("Access denied. Only business users can log in.");
            }
            if (data) {
              localStorage.setItem("accessToken", data.accessToken);
              localStorage.setItem("refreshToken", data.refreshToken);
              localStorage.setItem("authUser", JSON.stringify(data.user));
            }
            toast.success("Successfully subscribed!");
            setTimeout(() => {
              if (!subscriptionInfo.subscriptionStatus) {
                history.push("/add-card-details");
              } 
             
              else if (
                !businessProfile ||
                Object.keys(businessProfile).length === 0
              ) {
                history.push("/business-profile-edit");
              } 
              else {
                history.push("/business-profile");
              }
            }, 1500);
          })
          .catch((error) => {
            const messages =
              error?.response?.data?.responseMessage || ["Payment failed"];
            messages.forEach((msg) => toast.error(msg));
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        toast.error("Setup failed. Please try again.");
        setLoading(false);
      }
    } catch (err) {
      toast.error("Unexpected error occurred.");
      setLoading(false);
    }
  };
  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        {/* <Col md={12}>
          <Label>Email</Label>
          <Input
            type="email"
            value={email}
            placeholder="Enter your email"
            onChange={(e) => setEmail(e.target.value)}
          />
        </Col> */}
      </Row>
      <Row className="mt-3">
        <Col md={12}>
          <Label>Cardholder name</Label>
          <Input
            type="text"
            value={cardholder}
            placeholder="Enter your name"
            onChange={(e) => setCardholder(e.target.value)}
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col md={12}>
          <Label>Payment Details</Label>
          <div className="card-input">
            <PaymentElement options={{ layout: "tabs" }} />
          </div>
        </Col>
      </Row>
      <Button
        type="submit"
        disabled={!stripe || loading}
        className="mt-4 signin-btn w-100"
      >
        {loading ? "Processing..." : "Subscribe"}{" "}
        <i className="ms-2 fa-solid fa-arrow-right" />
      </Button>
    </Form>
  );
}
function CardDetails() {
  const [clientSecret, setClientSecret] = useState(null);
  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const [activePill, setActivePill] = useState("stripe");
  const location = useLocation();
  
  // Get planType from URL parameters
  const urlParams = new URLSearchParams(location.search);
  const planType = parseInt(urlParams.get('planType')) || 1;
  
  // Plan pricing mapping
  const planPricing = {
    1: 20,   // Standard
    2: 100   // Sponsored
  };
  
  const selectedPrice = planPricing[planType] || 20;

  const handlePillClick = (method) => {
    setActivePill(method);
  };
  
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };
  
  useEffect(() => {
    async function fetchClientSecret() {
      try {
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        const customerId = authUser?.stripeCustomerId || "68779fe49b6750e94186ad19";
        const token = localStorage.getItem("accessToken");
        const { data } = await ApiClient(token).post(
          "/business/payment/setupIntent",
          { stripeCustomerId: customerId }
        );
        setClientSecret(data.responseData.setupIntent.client_secret);
      } catch (error) {
        toast.error("Failed to initialize Stripe");
      }
    }
    fetchClientSecret();
  }, []);
  
  return (
    <React.Fragment>
      <ToastContainer />
      <div className="auth-page-content custom-auth-page">
        <MetaTags>
          <title>Payment Method | Findagram</title>
        </MetaTags>
        <div className=" d-flex align-items-center justify-content-between">
          <div className="logo-col ms-3">
            <Link to="/" className="logo-link">
              <img src={findagramLogo} alt="Findagram" height="60" />
            </Link>
          </div>

          <div>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className=" header-item topbar-user">
              <DropdownToggle tag="button" type="button" className="btn togglebtnheader shadow-none">
                <span className="d-flex align-items-center">
                  <i className="mdi mdi-account-circle text-muted fs-20 align-middle "></i>
                  <span className="text-start ms-xl-2">
                    <span className="d-none d-xl-inline-block fw-medium user-name-text">
                      {JSON.parse(localStorage.getItem("authUser"))?.firstName} {JSON.parse(localStorage.getItem("authUser"))?.lastName}
                    </span>
                  </span>
                </span>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem href="/logout"><i
                  className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                    className="align-middle" data-key="t-logout">Logout</span></DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
        <div className="header-line border-bottom"></div>
        <div
          className="background-section"
          style={{
            backgroundImage: `url(${loginbg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            minHeight: "calc(100vh - 100px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Container className="carddetail mt-3">
            <Col md={12} lg={8} xl={8} className="card-col">
              <Row className="justify-content-center">
                <Col md={12} className="text-center">
                  <h2 className="mb-4">Select Payment Method</h2>
                  <div className="d-flex justify-content-center gap-3 mb-4">
                    <Button
                      color={activePill === "stripe" ? "primary" : "light"}
                      className="rounded-pill px-4 py-2"
                      onClick={() => handlePillClick("stripe")}
                    >
                      Pay by Credit Card – <span className="fw-bold">${selectedPrice}/month</span> 
                    </Button>

                    <Button
                      color={activePill === "cash" ? "primary" : "light"}
                      className="rounded-pill px-4 py-2"
                      onClick={() => handlePillClick("cash")}
                    >
                      Cash Payment –  <span className="fw-bold">${selectedPrice}/month</span> 
                    </Button>

                    <Button
                      color={activePill === "e-transfer" ? "primary" : "light"}
                      className="rounded-pill px-4 py-2"
                      onClick={() => handlePillClick("e-transfer")}
                    >
                      E-Transfer Payment –  <span className="fw-bold">${selectedPrice}/month</span> 
                    </Button>
                  </div>
                </Col>
              </Row>
              <Card className="login-card">
                <CardBody className="card-body">
                  {activePill === "stripe" && (
                    <>
                    <p className="card-text mb-3 text-dark text-center">
                      Your card will be charged <span className="fw-bold">${selectedPrice}/month</span> to keep your Findagram dealer profile active. <br/>
                    </p>
                    <p className="small-textcard mt-2">
                        If you'd like to become a <span className="fw-bold">Sponsored Dealer</span>, please email us at
                        <a  href="mailto:contact@findagram.ca"> contact@findagram.ca</a>.
                    </p>
                    </>
                  )}
                  
                  {activePill === "stripe" ? (
                    clientSecret ? (
                      <Elements stripe={stripePromise} options={{ clientSecret }}>
                        <StripePaymentForm clientSecret={clientSecret} planType={planType} />
                      </Elements>
                    ) : (
                      <div className="text-center">Loading payment form...</div>
                    )
                  ) : activePill === "cash" ? (
                      <div className="d-flex flex-column justify-content-between">
                        <p className="mb-0 option-textcd">
                          Cash payments are only available in the <span className="fw-bold"> Greater Toronto Area (GTA). </span><br/>
                          To arrange a cash payment, please email us at <a href="mailto:contact@findagram.ca">contact@findagram.ca</a> to set up a meeting. <br />
                        </p>
                      
                      </div>
                  ) : (
                   <div className="d-flex flex-column justify-content-between">
                        <p className="mb-0 option-textcd">
                          To pay by e-transfer, please email us at <a href="mailto:contact@findagram.ca">contact@findagram.ca</a> and we will provide you with the payment details immediately. <br />
                     
                        </p>
                       
                       </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
}
export default CardDetails;